import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Tippy } from "@circle-react/components/shared/Tippy";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { CloseButton } from "../../../components/CloseButton";
import { usePaywallFormContext } from "../../PaywallFormProvider";

export const LeftContainer = () => {
  const { onClose } = usePaywallFormContext();
  const { watch } = useFormContext();
  const [displayNameWatcher, paywallId] = watch(["display_name", "id"]);

  const noPaywallNameAvailable = t(
    "settings.paywalls.modal.no_title_available",
  );

  const title = !paywallId
    ? t("settings.paywalls.modal.title_creation", {
        paywall_name: displayNameWatcher || noPaywallNameAvailable,
      })
    : t("settings.paywalls.modal.title_editing", {
        paywall_name: displayNameWatcher || noPaywallNameAvailable,
      });

  return (
    <>
      <div className="flex flex-row">
        <div className="border-primary hidden border-r pr-4 lg:block">
          <IconButton
            name="20-arrow-left"
            iconSize={20}
            buttonSize={28}
            className="text-default"
            iconClassName="!w-5 !h-5"
            ariaLabel={t("back")}
            onClick={() => onClose(true)}
          />
        </div>

        <span className={classNames("grid min-w-0 lg:ml-4")}>
          <Tippy content={title} className="truncate text-lg font-semibold">
            {title}
          </Tippy>
        </span>
      </div>
      <CloseButton onClick={() => onClose(true)} className="lg:hidden" />
    </>
  );
};
